/**
 * Interfaz de Escáner Físico por Hardware (Emulación de Teclado USB/Bluetooth)
 * Captura ráfagas rápidas de pulsaciones de teclas para decodificar DNI sin enfocar campos.
 * Cumple con .idx-rules.md: funciones < 40 líneas.
 */

import { getCurrentUser } from './router.js';

let buffer = '';
let lastKeyTime = Date.now();
const SPEED_THRESHOLD_MS = 45; // Milisegundos de tolerancia entre caracteres

/**
 * Registra el evento global para capturar escaneos por hardware.
 * @param {Function} onScanParsed Callback al detectar una lectura válida.
 */
export function initHardwareScanner(onScanParsed) {
  window.addEventListener('keydown', (e) => {
    // Verificar si hay un usuario autenticado activo
    if (!getCurrentUser()) return;

    // Ignorar si el usuario está editando campos de texto reales (evitar colisiones de escritura)
    const tag = document.activeElement ? document.activeElement.tagName : '';
    const isEditing = tag === 'INPUT' || tag === 'TEXTAREA';
    const isScannerInput = document.activeElement?.classList.contains('scanner-input');
    
    if (isEditing && !isScannerInput) {
      return; // Permite escribir contraseñas y configuraciones con normalidad
    }

    processKey(e, onScanParsed);
  });
}

/**
 * Procesa la tecla pulsada midiendo intervalos de tiempo.
 */
function processKey(e, callback) {
  const now = Date.now();
  const timeDiff = now - lastKeyTime;
  lastKeyTime = now;

  if (e.key === 'Enter') {
    // Si la lectura terminó y el buffer contiene datos válidos
    if (buffer.length > 12) {
      e.preventDefault();
      callback(buffer);
    }
    buffer = ''; // Reiniciar
    return;
  }

  // Capturar solo caracteres imprimibles individuales
  if (e.key.length === 1) {
    if (timeDiff > SPEED_THRESHOLD_MS) {
      // Velocidad humana: Reiniciar buffer con la tecla actual
      buffer = e.key;
    } else {
      // Velocidad máquina: Acumular carácter
      buffer += e.key;
    }
  }
}
